import type { FC } from "react";

import { IntentCell, TopicsCell } from "@similarweb/pro-logic-components";
import type { Topic } from "@similarweb/pro-logic-components/dist/table/cells/components/views/topics-cell/TopicsCell";
import type { StrictColor } from "@similarweb/styles";

import { percentageSignFilter } from "app/filters/ngFilters";

import { SOURCE_TYPES_CONFIG } from "./config";
import type { ISourceType } from "./types";

interface ISourceBadgeProps {
    sources: ISourceType[];
}

export const SourceBadge: FC<ISourceBadgeProps> = ({ sources }) => {
    const topics: Topic[] = sources
        .sort((a, b) => b.share - a.share)
        .map((st) => {
            const config = SOURCE_TYPES_CONFIG[st.name];

            return {
                label: config?.text,
                bgColor: config?.backgroundColor as StrictColor,
                textColor: config?.textColor as StrictColor,
                value: st.share && percentageSignFilter()(st.share, 0),
            };
        });

    const commonProps = {
        "data-automation-name": "source-types-cell",
    };

    return topics.length > 1 ? (
        <TopicsCell
            {...commonProps}
            topics={topics}
            tooltipProps={{
                placement: "left",
            }}
        />
    ) : topics.length === 1 ? (
        <IntentCell
            {...commonProps}
            {...topics[0]}
        />
    ) : null;
};
